import React from "react";

const Dine = (props) => {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "1em"}
      height={height ?? "1em"}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M4.616 19q-.691 0-1.153-.462T3 17.384v-9.73h1v9.73q0 .27.173.443t.443.173h6v1zM7.212 5.885q-.595 0-1.019-.425T5.77 4.442t.424-1.018T7.212 3q.613 0 1.028.424q.414.424.414 1.018T8.239 5.46t-1.028.424M12.442 21v-4.77h-5.23q-.595 0-1.019-.423t-.424-1.038V9.177q0-.644.437-1.084t1.055-.44q.437 0 .773.249q.335.248.616.54q1.067 1.11 2.249 2.045t2.736.936h1.85q-.53-.31-.844-.841q-.314-.532-.314-1.198h4.814q0 .666-.315 1.198t-.843.841H21v1h-3.77V21h-1v-8.577h-2.595q-1.421 0-2.627-.7t-2.354-1.75v4.777H12q.594 0 1.018.424t.424 1.018V21z"
      />
    </svg>
  );
};

export default Dine;
